import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { UserProfileComponent } from 'src/app/shared/components/user-profile/user-profile.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserType } from 'src/app/shared/constants/user-type.enum';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../providers/storage.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'sm-all-notifications',
  templateUrl: './all-notifications.component.html',
  styleUrls: ['./all-notifications.component.scss']
})
export class AllNotificationsComponent implements OnInit {

  messageLIst: any[] = [];
  count: number = 0
  loader:boolean = false
  imageThumbUrl: string = environment.profileImageBaseUrl;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "message",
      columnProperty: "message"
    }
  ];
  private _apiSubscription: Subscription;

  constructor(private _storageService: StorageService,private notificationService: NotificationService,private _apiService: ApiService, private _dialog: MatDialog, private router: Router, private route: ActivatedRoute,private _navService: NavigationService, private loaderservice: LoaderServiceService) {
    // this.messageLIst = USERS_LIST;
    this.listenForNotificationUpdates();
    this._navService.hideSidebarAndNav = false;
    


    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
     
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_NOTIFICATIONS){
        console.log(resData);
        // resData.result.length = resData.result.length > 5 ? 5 : resData.result.length
        this.messageLIst = resData.result ? resData.result : [];
        console.log( this.messageLIst);
        this.loader = false
        this.loaderservice.showLoader = false
        let unreadNotifications = this.messageLIst.filter((item:any) => (item.read_status == 0)).map((item:any) => {return item.hash_id})
        console.log('unread',unreadNotifications);
        
        if(unreadNotifications.length > 0){
          
          
          let bodyData = {
            hashes: unreadNotifications,
            status: 1,
            account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
          }
          this._apiService.setNotificationReadStatus(bodyData)
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_SET_NOTIFICATION_READ_STATUS){
        if(resData.result){
          this._apiService.getMessageNotificationStatus()
        }
      }
     
    });
  }

  ngOnInit(): void {
    this.loader = true
    this.loaderservice.showLoader = true
    this._apiService.getNotifications()
  }

  private notisubscription: Subscription = new Subscription();
  listenForNotificationUpdates() {
    this.notisubscription = this.notificationService.getNotificationByType('onNewAdminMessage')
      .subscribe(payload => {
        if(true){
          console.log('New notification received:', payload);
          this.createNotification(payload.data.title, payload.data.message)
          this._apiService.getNotifications()
          

        }
      });
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  viewProfile(profileData: any){
    this._dialog.open(UserProfileComponent, {
      data: profileData,
      maxWidth: 370,
      panelClass: 'user-profile-dialog'
    });
  }
  viewBusiness(value: any){
    console.log("click");
    this._storageService.setValueInAppStorage('specificEntityHash', value.hashId)
    this._storageService.setValueInAppStorage('specificEntityName', value.name)
    this.router.navigate(['users','entity-business'], {relativeTo: this.route})
    
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    if (this.notisubscription) {
      this.notisubscription.unsubscribe();
    }
  }

}
